/** Query keys for the leads table, scoped to the record it is rendered under. */
export const leadKeys = {
  all: ["leads"],
  lists: () => [...leadKeys.all, "list"],
  list: ({ scope = null, id = null } = {}) => [
    ...leadKeys.lists(),
    { scope, id },
  ],
};
